<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

const props = defineProps({
  loading: { type: Boolean, default: false },
  search: { type: String, default: '' },
  sort: { type: String, default: 'updated_desc' },
});

const emit = defineEmits(['update:search', 'update:sort']);
const { t } = useI18n();
const searchValue = computed({
  get: () => props.search,
  set: value => emit('update:search', value),
});
const sortValue = computed({
  get: () => props.sort,
  set: value => emit('update:sort', value),
});
</script>

<template>
  <section
    class="grid gap-3 rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card md:grid-cols-[minmax(0,1fr)_240px]"
  >
    <LaisField :label="t('REAL_ESTATE_BROKER_INVESTMENT.FILTERS.ADDRESS')">
      <input
        v-model="searchValue"
        type="search"
        :disabled="loading"
        class="min-h-10 rounded-lais border border-lais-border px-3 text-sm"
      />
    </LaisField>
    <LaisField :label="t('REAL_ESTATE_BROKER_INVESTMENT.FILTERS.ORDER')">
      <select
        v-model="sortValue"
        :disabled="loading"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
      >
        <option value="updated_desc">
          {{ t('REAL_ESTATE_BROKER_INVESTMENT.SORT.UPDATED_DESC') }}
        </option>
        <option value="updated_asc">
          {{ t('REAL_ESTATE_BROKER_INVESTMENT.SORT.UPDATED_ASC') }}
        </option>
        <option value="value_desc">
          {{ t('REAL_ESTATE_BROKER_INVESTMENT.SORT.VALUE_DESC') }}
        </option>
        <option value="value_asc">
          {{ t('REAL_ESTATE_BROKER_INVESTMENT.SORT.VALUE_ASC') }}
        </option>
      </select>
    </LaisField>
  </section>
</template>
